module.exports = __webpack_public_path__ + "img/Weilin Vision Software-Volume Dynamic Recognition.843ec6f1.jpg";